<template>
  <div class="swiper-container">
      <!-- swiper-wrapper -->
      <div class="swiper-wrapper">
          <!-- Slides -->
          <div class="swiper-slide">법인카드전표<button class="close-icon"><i class="fas fa-times"></i></button></div>
          <div class="swiper-slide">기타증빙<button class="close-icon"><i class="fas fa-times"></i></button></div>
          <div class="swiper-slide">기타증빙<button class="close-icon"><i class="fas fa-times"></i></button></div>
          <div class="swiper-slide">세금계산서 전표<button class="close-icon"><i class="fas fa-times"></i></button></div>
          <div class="swiper-slide">법인카드전표<button class="close-icon"><i class="fas fa-times"></i></button></div>
          <div class="swiper-slide">기타증빙<button class="close-icon"><i class="fas fa-times"></i></button></div>
          <div class="swiper-slide">기타증빙<button class="close-icon"><i class="fas fa-times"></i></button></div>
          <div class="swiper-slide active">세금계산서 전표<button class="close-icon"><i class="fas fa-times"></i></button></div>
          <div class="swiper-slide">법인카드전표<button class="close-icon"><i class="fas fa-times"></i></button></div>
          <div class="swiper-slide">기타증빙<button class="close-icon"><i class="fas fa-times"></i></button></div>
          <div class="swiper-slide">기타증빙<button class="close-icon"><i class="fas fa-times"></i></button></div>
          <div class="swiper-slide">세금계산서 전표<button class="close-icon"><i class="fas fa-times"></i></button></div>
          <div class="swiper-slide">법인카드전표<button class="close-icon"><i class="fas fa-times"></i></button></div>
          <div class="swiper-slide">기타증빙<button class="close-icon"><i class="fas fa-times"></i></button></div>
          <div class="swiper-slide">기타증빙<button class="close-icon"><i class="fas fa-times"></i></button></div>
          <div class="swiper-slide ">세금계산서 전표<button class="close-icon"><i class="fas fa-times"></i></button></div>
      </div>
      <!-- //swiper-wrapper -->

      <!-- tab button  -->
      <div class="swiper-button-prev">
          <button><span class="arrow-icon"><i class="fas fa-chevron-left"></i></span></button>
      </div>
      <div class="swiper-button-next">
          <button><span class="arrow-icon"><i class="fas fa-chevron-right"></i></span></button>
      </div>
      <!-- //tab button  -->
  </div>   
</template>

<script>
export default {
  name: 'Swifer',
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
